import React from 'react';
import { BasePage } from '@components';
import {
  PlatformType,
  useUpdateUserSessionInfoMutation,
} from '@fdha/graphql-api-sitestaff';
import { LoginV2 } from '@fdha/web-auth';

export const Login = () => {
  const [updateUserSessionInfo] = useUpdateUserSessionInfoMutation();

  const handleSignIn = async () => {
    await updateUserSessionInfo({
      variables: {
        props: {
          platform: PlatformType.Web,
          action: 'login',
        },
      },
    });
  };

  return (
    <BasePage
      type="default"
      contentSize="xsmall"
      verticallyCentered={true}
      headerProps={{
        title: 'Welcome',
        subtitle: 'Please enter your account information',
        showBack: false,
        showLogo: true,
        centeredHeader: true,
      }}
    >
      <LoginV2 onSignIn={handleSignIn} />
    </BasePage>
  );
};
